@font-face {
  font-family: 'industrie-standard';
  src: url('/assets/fonts/industrie/FSIndustrieVFStd.woff2') format('woff2'), url('/assets/fonts/industrie/FSIndustrieVFStd.ttf') format('truetype');
  font-weight: 100 900;
  font-display: fallback;
}

:host {
  --Text-Primary: var(--Text-Primary, #202121);
  --text-footer-color: #181818;
  --text-secondary-color: #5f5f5f;
  --Text-Tertiary: var(--Text-Tertiary, #767676);
  --text-positive-color: #04802d;
  --text-negative-color: #cc0e00;
  --text-white-color: #ffffff;
  --subscribe-button-color: var(--Brand-Primary, #004ace);
  font-family: 'FS Industrie', FSIndustrie-Bold, industrie-standard, Helvetica, Arial, sans-serif;
  display: block;
  width: 100%;
}

section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.sportsline-free-expert-pick__header {
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
    & sportsline-free-expert-pick-header {
      flex: 0 1 30%;
      min-width: 240px;
    }
  }
}

.sportsline-free-expert-pick__footer {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

sportsline-divider {
  display: none;
  width: 100%;
  @media screen and (min-width: 768px) {
    display: block;
  }
}

sportsline-company-logo {
  display: none;
}

sportsline-free-expert-pick-selection {
  flex: 1;
}
